<template>
    <div>

        <div v-if="accommodation.modalidad_tiempo === 'diario'">
            <strong class="price">{{ logAndShowPrice(dailyPrice, 'diario') }}</strong>
            <span class="rental-mode ml-2">{{ $t("reservation.per-day") }}</span>
        </div>

        <div v-if="accommodation.modalidad_tiempo === 'mensual'">
            <strong class="price">{{ logAndShowPrice(monthlyPrice, 'mensual') }}</strong>
            <span class="rental-mode ml-2">{{ $t("reservation.per-month") }}</span>
        </div>

        <div v-if="accommodation.modalidad_tiempo === 'ambos'">
            <strong class="price">{{ logAndShowPrice(monthlyPrice, 'ambos-mensual') }}</strong>
            <span class="rental-mode ml-2">{{ $t("reservation.per-month") }}</span>
            <br/>
            <span class="reservation-per-day">
            <span class="rental-mode">* {{ logAndShowPrice(dailyPrice, 'ambos-diario') }}</span>
            <span class="rental-mode ml-2">{{ $t("reservation.per-day") }}</span>
        </span>
        </div>

    </div>    
</template>

<script>
export default {
    name: "Price",
    props: {
        accommodation: Object,
        dailyPrice: Object,
        monthlyPrice: Object
    },
    methods: {
        logAndShowPrice(price, tipo) {
            let value;
            if (this.$options.filters && this.$options.filters.convertPriceToInteger) {
                value = this.$options.filters.convertPriceToInteger(price);
                // ...existing code...
            } else {
                value = '[FILTRO NO DISPONIBLE] ' + (price && price.amount ? price.amount : JSON.stringify(price));
                console.error('[Price.vue] Filtro convertPriceToInteger NO disponible', price);
            }
            return value;
        }
    }
};
</script>

<style lang="scss" scoped>

.price {
    font-size: 1.3rem;
    color: black !important;
    z-index: 9999 !important;
}

.rental-mode {
    font-size: 1.1rem;
}
</style>